import { useSyncExternalStore } from 'react';

/**
 * ⛔ s966 (владелец 25.10.2026): «когда отключат УС — все кнопки с ним связанные нужно
 * будет удалить». День X (`den_x` = `nash`) приезжает с сервера в `/auth/me` → `den_x`.
 * До дня X ничего не меняется; с дня X каждая кнопка и ссылка в УС снимается с экрана
 * целиком — без замены, без пояснений. Двери сервера (409) остаются второй защитой.
 *
 * Общий кэш модуля, а не запрос в каждом месте: ссылки в УС живут и в крошечных
 * компонентах без провайдера запросов (мини-карточка звонка, строка расчёта). Кэш
 * наполняет `useMe`; пока ответа нет — «до дня X», то есть экран как был.
 */
let nastupil = false;
const slushateli = new Set<() => void>();

/** Запомнить флаг дня X из ответа сервера (`/auth/me` → `den_x`). */
export function zapomnitDenX(znachenie: boolean | null | undefined): void {
  const novoe = znachenie === true;
  if (novoe === nastupil) return;
  nastupil = novoe;
  slushateli.forEach((f) => f());
}

function podpisatsya(f: () => void): () => void {
  slushateli.add(f);
  return () => {
    slushateli.delete(f);
  };
}

const snimok = () => nastupil;

/** Убраны ли с экрана кнопки и ссылки УС: `true` — день X настал. */
export function useBezUs(): boolean {
  return useSyncExternalStore(podpisatsya, snimok, snimok);
}

